module.exports = __webpack_public_path__ + "static/the-tb12-method-146e96daa37e1d48ad1b863f3b82a16d.jpg";